import { createReducer } from "@reduxjs/toolkit";
import {
    loadingTastePanelDetail,
    deleteTastePanelDetailAsync,
    AddTastePanelDetail,
    removeUnsavedTastePanelDetail,
    updateTastePanelDetailValue,
    getTastePanelDetailListAsync,
    saveTastePanelDetailsAsync,
} from "./tastePanelDetailAction";
import { TastePanelDetail } from "src/dataAccess/tastePanel/tastePanelDetail.DataAccess";

interface TastePanelDetailWithKey extends TastePanelDetail {
    key?: string | number;
}

export interface ITastePanelDetailState {
    detailList: TastePanelDetailWithKey[];
    isLoading: boolean;
}

const initialState: ITastePanelDetailState = {
    detailList: [],
    isLoading: false,
};

export const tastePanelDetailReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(loadingTastePanelDetail, (state, action) => {
            state.isLoading = action.payload;
        })
        .addCase(getTastePanelDetailListAsync.fulfilled, (state, action) => {
            state.detailList = action.payload.map(item => ({
                ...item,
                key: item.id
            }));
        })
        // Remove this case to prevent double updates
        // .addCase(saveTastePanelDetailsAsync.fulfilled, (state, action) => {
        //     state.detailList = action.payload.map(item => ({
        //         ...item,
        //         key: item.id
        //     }));
        // })
        .addCase(AddTastePanelDetail, (state, action) => {
            state.detailList.push({
                ...action.payload,
                key: action.payload.id || Date.now(),
            });
        })
        .addCase(deleteTastePanelDetailAsync.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.detailList = state.detailList.filter(
                    (item) => String(item.id) !== String(action.payload.id)
                );
            }
        })
        .addCase(removeUnsavedTastePanelDetail, (state, action) => {
            state.detailList = state.detailList.filter(item => item.key !== action.payload);
        })
        .addCase(updateTastePanelDetailValue, (state, action) => {
            state.detailList = (action.payload as TastePanelDetailWithKey[]).map(item => ({
                ...item,
                key: item.id || item.key
            }));
        });
});
